<!-- tab selection start -->
@if (checkLinkActive()) {
<div class="support-content">
    <ul class="nav nav-tabs detailed-tabs relative page-sub-heading" role="tablist">
        <!-- @if (permissionmodules.includes('TRIPS')){
        <li class="nav-item" routerLinkActive="active">
            <a [routerLink]="['/trips']"
                [class.active]="router.isActive('/location-history', false) || router.isActive('/location-history?searchBy=&value=', false) || router.isActive('/trips', false)"
                (click)="tabPos = 0;" class="nav-link text-center mt-1" href="#history">
                <i class="fa fa-history"></i> History
            </a>
        </li>
        } -->
        <!--@if (permissionmodules.includes('DATA')) {
        <li class="nav-item" routerLinkActive="active">
            <a [routerLink]="['/data/messages']" (click)="goToTrips('messages')" [class.active]="
            router.isActive('/data/messages', true) ||
            router.isActive('/data/location-history', false)
          " (click)="tabPos = 1;" class="nav-link text-center mt-1" href="#messages">
                <i class="fa fa-envelope"></i> Message Data
            </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
            <a [routerLink]="['/data/trips']" (click)="goToTrips('trips')" [class.active]="
            router.isActive('/data/trips', true)
          "
                (click)="tabPos = 2;" class="nav-link text-center mt-1" href="#trips">
                <i class="fa fa-map-o"></i> Trip Data
            </a>
        </li>
        @if (permissionmodules.includes('DATA') && permissionmodules.includes('DESTINATION')) {
        <li class="nav-item tab-divider" role="presentation" aria-hidden="true"></li>
        }
        } -->
        @if (permissionmodules.includes('DESTINATION')) {
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
            <a [routerLink]="['/destinations']" (click)="tabPos = 0;" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link text-center mt-1" href="#destinations">
                <i class="fa-solid fa-sitemap"></i> Destinations
            </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
            <a [routerLink]="['/destinations/data-schemes']" (click)="tabPos = 1;" routerLinkActive="active" class="nav-link text-center mt-1" href="#schemes">
                <i class="fa-solid fa-random"></i> Data Schemes
            </a>
        </li>
        <!-- <li class="nav-item" routerLinkActive="active">
            <a [routerLink]="['/destinations/replay-data']" (click)="tabPos = 5;" routerLinkActive="active" class="nav-link text-center mt-1" href="#replay-data">
                <i class="fa-solid fa-rotate-right"></i> Replay Data
            </a>
        </li> -->
}
        <!-- @if (permissionmodules.includes('DESTINATION') && permissionmodules.includes('DATASIMULATOR')) {
        <li class="nav-item tab-divider" role="presentation" aria-hidden="true"></li>
        }
        @if (permissionmodules.includes('DATASIMULATOR')) {
<li class="nav-item" routerLinkActive="active">
            <a [routerLink]="['/data-simulator']" (click)="tabPos = 6;" routerLinkActive="active"
                class="nav-link text-center mt-1" href="#simulator">
                <i class="fa-solid fa-route"></i> Data Simulator
            </a>
        </li>
} -->
    </ul>
</div>
}